      var specific_location='';
      var delivery_grp='';
      var enable_zip_validate=true;
      var add_postalcode;
      var index_one;
      var index_two;
      var enable_option = 'true';
      var method_type='delivery';
      var geocoder;
      var map;
      var mapPostCode='';
      var special_collection_date = special_collection_dates;

$(document).ready(function(){
    update_empty_attributes();
    show_storepickups();
  	jQuery('.shipping_option input[name="attributes[Type]"]').on('click',function(){
      	if($('input[name="attributes[Type]"]:checked').val() == "pickup"){
           show_storepickups();
           jQuery(".location_single").show();
        }
      else if($('input[name="attributes[Type]"]:checked').val() == "delivery"){
      		$(".roses_shipping input:radio").attr("checked", false);
        	 update_empty_attributes();
             method_type='delivery';
      }
	});
  
  	jQuery('.roses_shipping .roses_ship_method input[name="method_pickup"]').on('click', function(){
        if($('.roses_shipping input[name="method_pickup"]:checked').val()){
            var location_detail=$('.roses_shipping input[name="method_pickup"]:checked').val();
            $(".delivers input:radio").attr("checked", false);
            $('.storepickups input[name="attributes[Type]"]').prop("checked", true);
            method_type='pickup';
            specific_location=location_detail;
            update_attributes(location_detail);
        }
  	});
	jQuery(".zero_step [name=checkout_zero]").on("click", function(e) { console.log(123);
  		e.preventDefault();
    	if ($("input[name='attributes[Type]']:checked").val()) { console.log($("input[name='attributes[Type]']:checked").val());
       		if ($("input[name='attributes[Type]']:checked").val()=='pickup') {
        		if (!$("input[name='method_pickup']:checked").val()) {
        			jQuery('.shipping_option .error_method').html('<p>Please select the Location</p>');
    			}
              	else{                  
                  jQuery('.tab_based_content').show();                  
                  $("section.recipentField .hideonpickup input[name='attributes[Delivery-Address-of-Recipient]']").val('');
                  $("section.recipentField .hideonpickup textarea[name='attributes[Special-Instruction-for-Courier]']").val('');
                  jQuery('section.recipentField .hideonpickup').hide();
                  jQuery('html, body').animate({
                     scrollTop: (jQuery('.site-header').offset().top - 100)
                   }, 1250);
                  jQuery('form .section-header, form .cart-item, form .checkout-update, form .shipping_option, form .zero_step, form .checkout-options, form .cart-page .product-cart').addClass('hideOnPopup');
              	}
    		}
          	else if($("input[name='attributes[Type]']:checked").val()=='delivery'){              
               jQuery('.tab_based_content').show();
               jQuery('html, body').animate({
                     scrollTop: (jQuery('.site-header').offset().top - 150)
                   }, 1250);                   
			   jQuery('form .section-header, form .cart-item, form .checkout-update, form .shipping_option, form .zero_step, form .checkout-options, form .cart-page .product-cart').addClass('hideOnPopup'); 
          	}
    	}
    	else{
       		jQuery('.shipping_option .error_method').html('<p>Please select the Delivery Option</p>');
    	}
  	});
  
  jQuery("#cart_tabs").steps({
    headerTag: "h3",
    bodyTag: "section",
    transitionEffect: "slideLeft",
    autoFocus: true,
    enableFinishButton: false,
    onInit: function (event, current) {
        $('.actions > ul > li:first-child').attr('style', 'display:none');
        initialize();
         if (enable_option == 'true') {
           index_one = 2;
           index_two = 3;
         } else {
           index_one = 1;
           index_two = 2;
         }
    },
    onStepChanging: function (event, currentIndex, newIndex){
          
      if(currentIndex==0&&newIndex==1){
        var submit=true;
        //var gift_receiver=jQuery('#cart_tabs select#gift_receiver').val();
        // var firstname=jQuery('#cart_tabs input#recipient_firstname').val();
        // var lastname=jQuery('#cart_tabs input#recipient_lastname').val();
        // var delivery_address=jQuery('#cart_tabs input#delivery_address').val();
        // var special_instruction=jQuery('#cart_tabs input#special_instruction').val();
        var gift_message=jQuery('#cart_tabs textarea#gift_message').val();
        var ocassion=jQuery('#cart_tabs select#ocassion').val();
        var locationmsg=jQuery('#cart_tabs select#locationmsg').val();
         add_postalcode=jQuery('#cart_tabs input#address_postalcode').val();
        
        //if(!gift_receiver){
          		//jQuery('#cart_tabs section div.error_relation').html('Select Receiver');
          		//submit=false;
        	//}
        // if(!firstname){
        //   		jQuery('#cart_tabs section div.error_first').html('Enter First Name');
        //   		submit=false;
        // 	}
        // if(!lastname){
        //   		jQuery('#cart_tabs section div.error_last').html('Enter Last Name');
        //   		submit=false;
        // 	}
        if(!ocassion){
            jQuery('#cart_tabs section div.error_ocassion').html('Please Select Ocassion');
            submit=false;
        }
        if(!locationmsg && method_type=='delivery'){
          jQuery('#cart_tabs section div.error_locationmsg').html('Please Select Delivery Location');
          submit=false;
      }
        //  if(method_type=='delivery'){
        // if(!delivery_address){
        //   		jQuery('#cart_tabs section div.error_address').html('Enter Deliver Address');
        //   		submit=false;
        // 	}
        //          else{
        //      if(add_postalcode){
        //       var dowedeliver=checkIfDelivered(add_postalcode);
        //        if(!dowedeliver){
        //        submit=false;
        //          jQuery('#cart_tabs section div.error_address').html('We don\'t deliver here');
        //        }
        //      }
        //    }
        //  }
        if(submit==false){ return submit; } 
               else{
          	 if (enable_option == 'true') {
                   
                    jQuery('.products-carouselnew').each(function(index) {
                      if(!jQuery(this).find('.slick-initialized').length){
                      var id = jQuery(this).attr('data-container');
                      jQuery('.integrateFlexslider_'+id).slick({
                      dots: false,
                      arrows: true,
                      adaptiveHeight: true,
                      infinite: false,
                      slidesToShow: 3,
                      slidesToScroll: 1,
                      responsive: [
                      {
                        breakpoint: 1024,
                        settings: { slidesToShow: 3, slidesToScroll: 1 }
                      },
                      {
                        breakpoint: 768,
                        settings: { slidesToShow: 1, slidesToScroll: 1 }
                      },
                      ]
                    });   
                        jQuery(window).trigger('resize');
                        }
                      });
                      return true;
                } else {
                        
						dynamic_option(method_type, ebzapiets_delivery, add_postalcode,numberofspecialproduct,special_collection_date);
                    }
        }
      }

            if (enable_option == 'true') {
                if (currentIndex == 1 && newIndex == 2) {
					dynamic_option(method_type, ebzapiets_delivery, add_postalcode,numberofspecialproduct,special_collection_date)
                }
            }
      
      if(currentIndex == index_one &&newIndex == index_two){
            var submit=true;
        	if(method_type=='delivery'&&enable_zip_validate){
              if(delivery_grp){
                var delivery_postalcode=jQuery('.choose_date input#postal_code').val().trim();
              
              if (delivery_postalcode == '') {
                jQuery('.choose_date div.error_postal').html('Please Enter Postcode.');
                return false;
              }
            //POST CODE VALIDATION
            var obj=  ebzapiets_delivery ;
            var storepick_data=jQuery.parseJSON(obj);
            var selected_location=getDescendantProp(storepick_data, delivery_grp);

            if(selected_location.zipcode.enable_zipcode){
              var postcode_string=selected_location.zipcode.zip_codes;
              var postcode_array = postcode_string.split(",");
              var postal_code_found=0;
              var delivery_postalcode=jQuery('.choose_date input#postal_code').val().trim();
              var postcode_found=false;
              
              if (delivery_postalcode == '') {
                jQuery('.choose_date div.error_postal').html('Please Enter Postcode.');
                return false;
              }
              else{
               		var postal_code=delivery_postalcode;
                	var postal_codeLower=postal_code.toLowerCase();
                    if(selected_location.zipcode.validation_type==1){
                          for(var i in postcode_array){
							var single_value_trim=postcode_array[i].trim();
                           	if(single_value_trim){
                              var singleValueLower=single_value_trim.toLowerCase();
                              if(postal_codeLower!=singleValueLower){
                              		jQuery('.choose_date div.error_postal').html('Sorry, the delivery is not available in that Postcode.');
                                //return false;
                              }
                              else{
                                var postcode_found=true;
                                jQuery('.choose_date div.error_postal').html('');
                              	submit=true;
                                break;
                              }
                            }
                         }
                    }
                    else if(selected_location.zipcode.validation_type==2){
                      
                        for(postcode in postcode_array){
                            var single_value_trim=postcode_array[postcode].trim();
                            if(single_value_trim){
                                var singleValueLower=single_value_trim.toLowerCase();
                                if(postal_codeLower.indexOf(singleValueLower)==0){
                                    jQuery('.choose_date div.error_postal').html('');
                                    submit=true;
                                    postcode_found=true;
                                    break;
                                }
                            }
                        }
                      
                    }
                 if(!postcode_found){
                         jQuery('.choose_date div.error_postal').html('Sorry, the delivery is not available in that postcode.');
                         return false;
                       }
              }
            }
              if(!jQuery('#datepicker').hasClass('hasDatepicker')){
              	 	jQuery('.choose_date .datepickerWrapper').html('<span class="formatteddate"></span><input type="hidden" name="attributes[Delivery-Date]" id="date_picker" placeholder="Please Choose Date above." required readonly /><div class="error_datepicker"></div>');
                  
                  	var push_d=offsetdata('delivery',delivery_grp);
                   if(!push_d){ push_d=0; }
          		    var dateToday = new Date(get_timezone_date('+8'));
       
                    var myday=dateToday.setDate(dateToday.getDate() + parseInt(push_d));
                    var push=new Date(myday);
					
                    jQuery("#datepicker").datepicker({
                          dateFormat: 'yy/mm/dd',
                          minDate: push,
                          firstDay: 1,
                          showOtherMonths: true,
                          selectOtherMonths: false,
                          beforeShowDay: function (date){
                              return noWeekendsOrHolidays(date, 'delivery', delivery_grp,numberofspecialproduct,special_collection_date);
                          },
                          onSelect: function(dateText, instobj) {
                            var selectedDate = $(this).val();
                            var msg_for_special_date = specialdatemessage(special_collection_date,numberofspecialproduct,selectedDate);
                            if (msg_for_special_date) {
                              jQuery('error_datepicker').html('');
                              jQuery('input[name="checkout[attributes][Delivery-Date]"]').val('');
                              jQuery('#time_of_day').hide();
                              jQuery('span.formatteddate').html(sptext).css({'color': '#a81c20','font-style': 'bold','font-size': '12px'});
                            }
                            else {
                              jQuery(this).data('datepicker').inline = true;
                              jQuery('input[name="attributes[Delivery-Date]"]').val(dateText);
                              cltr=dateFormat(dateText,'dddd dS mmm yyyy');
                              jQuery('span.formatteddate').html(cltr);
                              jQuery('.error_datepicker').html('');
                              jQuery('#time_of_day').show();
                              populate_date(dateText, 'delivery', specific_location);
                              $("#time_of_day select").niceSelect();
                            }
                          }
                    });
                   jQuery('.delivery-note').html('Please select date and we will load available time.');
                	jQuery('.choose_date div.error_postal').html('');
                  setTimeout(function() {
        $(document).find('td.ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
     }, 100);
              }
            }
      }
            //POST CODE VALIDATION
            var date_to_submit=jQuery('.choose_date .datepickerWrapper input#date_picker').val();
            if(!date_to_submit){
              jQuery('.choose_date div.error_datepicker').html('Please choose a date.');
              submit=false;
            }

            if(jQuery('#cart_tabs #time_of_day').find('select#popup_time').length){
              var time_to_submit=jQuery('#time_of_day select#popup_time').val();
              if(!time_to_submit){
                jQuery('#time_of_day div.error_popuptime').html('Please choose a time.');
                submit=false;
              }
            }
        
        	if(jQuery('#cart_tabs #time_of_day').find('select#delivery_time').length){
              var time_to_submit=jQuery('#time_of_day select#delivery_time').val();
              if(!time_to_submit){
                jQuery('#time_of_day div.error_popuptime').html('Please choose a time.');
                submit=false;
              }
            }
        

            if(submit){
              jQuery("input[name='checkout']").trigger('click');
            }

            return submit;
      }
      return true;
    },
     onStepChanged:function (event, currentIndex, priorIndex){
  
      if(currentIndex==1){
        jQuery('.continue_btns a').one('click',function(){
          	jQuery('.actions ul li a[href=#next]').trigger('click');
        });
      }
      if(currentIndex==index_one){
         jQuery('.choose_date input#postal_code').trigger('blur');
         }
    },
    labels: {
        finish: 'Continue',
        next: 'Continue',
    }
  });
  
  //$('#cart_tabs select#gift_receiver').on('click',function(){
  	//jQuery('#cart_tabs section div.error_relation').html('');
  //});
  //  $('#cart_tabs input#recipient_firstname').on('focus',function(){
  // 	jQuery('#cart_tabs section div.error_first').html('');
  // });
  // $('#cart_tabs input#recipient_lastname').on('focus',function(){
  // 	jQuery('#cart_tabs section div.error_last').html('');
  // });
  // $('#cart_tabs input#delivery_address').on('focus',function(){
  // 	jQuery('#cart_tabs section div.error_address').html('');
  // });
  $('#cart_tabs select#ocassion').on('click',function(){
  	jQuery('#cart_tabs section div.error_ocassion').html('');
  });
  $('#cart_tabs select#locationmsg').on('click',function(){
  	jQuery('#cart_tabs section div.error_locationmsg').html('');
  });
  
    $('form.cart').find('input').keypress(function(e){
    	if ( e.which == 13 ) { // Enter key = keycode 13    
      		$(this).next().focus();  //Use whatever selector necessary to focus the 'next' input
      		return false;
    	}
 	});
  
  
}); // end of document.ready
 
function noWeekendsOrHolidays(date, method_type, specific_location,numberofspecialproduct,special_collection_date){
  var day = date.getDay();
  var weekday=['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
  var weekdeliveryday=['sunday_disable','monday_disable','tuesday_disable','wednesday_disable','thursday_disable','friday_disable','saturday_disable'];
  
  if(method_type){
   		if(method_type=='pickup'){
            var obj=  ebzapiets ;
            var storepick_data=jQuery.parseJSON(obj);
            var selected_location=getDescendantProp(storepick_data, specific_location);
          	var days_list=selected_location.days;
          	
            var black_week= [];
            for(var i in weekday){
                var info_day=weekday[i];
                if(days_list[info_day]){
                    if(days_list[info_day].disable){
                      ii=parseInt(i);
                      black_week.push(ii);
                    }
                }
            }

          if(black_week){
            if(jQuery.inArray( day, black_week )>=0){
                return [false];
            }
            else{
                if(nationalDays(date, method_type, specific_location,numberofspecialproduct,special_collection_date)){
                    return [true]; }
                else{
                    return [false]; }
            }
          }
          else{
            if(nationalDays(date, method_type, specific_location,numberofspecialproduct,special_collection_date)){
                    return [true]; }
                else{
                    return [false]; }
          }
          //end
          
        }
    	 else if(method_name='delivery'){
          	var obj=  ebzapiets_delivery ;
			var storepick_data=jQuery.parseJSON(obj);
            var selected_location=getDescendantProp(storepick_data, specific_location);
           	var days_list=selected_location.slot;
           
           
            var black_week= [];
            for(var i in weekdeliveryday){
                var info_day=weekdeliveryday[i];
                if(days_list[info_day]==1){
                      ii=parseInt(i);
                      black_week.push(ii);
                }
            }

          if(black_week){
            if(jQuery.inArray( day, black_week )>=0){
                return [false];
            }
            else{
                if(nationalDays(date, method_type, specific_location,numberofspecialproduct,special_collection_date)){
                    return [true]; }
                else{
                    return [false]; }
            }
          }
          else{
            if(nationalDays(date, method_type, specific_location,numberofspecialproduct,special_collection_date)){
                    return [true]; }
                else{
                    return [false]; }
          }
          //end
           
           	
           
        }
  }

    return [true]; 
}

function nationalDays(date,method_type, specific_location,numberofspecialproduct,special_collection_date){
     if(method_type){
   		if(method_type=='pickup'){
            var obj=  ebzapiets ;
            var storepick_data=jQuery.parseJSON(obj);
            var selected_location=getDescendantProp(storepick_data, specific_location);
        }
    	 else if(method_name='delivery'){
          	var obj=  ebzapiets_delivery ;
			var storepick_data=jQuery.parseJSON(obj);
            var selected_location=getDescendantProp(storepick_data, specific_location);
        }
  
        if(selected_location['blackout']){
        	disabledDays=selected_location['blackout'];
            if (numberofspecialproduct) {
              disabledDays = '';
            }
            if (!numberofspecialproduct) {
             //var special_collection_date =special_collection_date.split(",");
             //disabledDays = disabledDays.concat(special_collection_date);
            }
            
              var m = date.getMonth(), d = date.getDate(), y = date.getFullYear();
              for (i = 0; i < disabledDays.length; i++) {
                if($.inArray( y + '-' +(m+1) + '-' + d ,disabledDays) != -1 ) {
                    return false;
                }
            }
          
            
            
            if (!disabledDays) {
             
             //var push=new Date(myday);
             var special_collection_date =special_collection_date.split(",");
             var sDate = date.getDate().toString() + "/" + (date.getMonth()+1).toString() + "/" + date.getFullYear().toString();
             
             if($.inArray( y + '-' +(m+1) + '-' + d ,special_collection_date) != -1 ) {
                    return true;
                }
              else { return false}
          }
       	}
   }
  return true;
}

function show_storepickups(){
  	 var obj=  ebzapiets ;
     var storepick_data=jQuery.parseJSON(obj);
     var show_storepick = false;
     var single_data;
	 var store_html='<div class="roses_shipping">';
     var first_iteration = true;
     for(single_data in storepick_data ){
         var all_data=storepick_data[single_data];
       	 if(all_data.enable_location){
            if(all_data.offset){
            show_storepick = true;
         	if (first_iteration) {var status=""; first_iteration = false;} else{ var status="";}
         	store_html+='<div class="roses_ship_method"><input type="radio" name="method_pickup" value="' + single_data + '"'+ status +' id="'+single_data+'"/><label class="location_specs" for="'+single_data+'">'+all_data.location_name+', '+all_data.address_one+' '+all_data.city+' '+all_data.postal_code +'</label><span class="ie_pick">'+all_data.location_name+', '+all_data.address_one+' '+all_data.city+' '+all_data.postal_code +'</span></div>';
            }
            }
     }
     store_html+='</div>';
  		var obj=  ebzapiets_delivery ;
        var selected_location=jQuery.parseJSON(obj);
  
  var enable_delivery=false;
  for(var i in selected_location){
    if(selected_location[i].enable_delivery){
    	enable_delivery=true;
      	break;
    }
  }

  if (!enable_delivery) {
        jQuery('.shipping_option .delivers').hide();
    }

    if (show_storepick) {
        jQuery('.location_single').html(store_html);
    } else {
        jQuery('.shipping_option .storepickups').hide();
        jQuery('.shipping_option').hide()
    }
}


function update_attributes(details){
     var obj=  ebzapiets ;
     var storepick_data=jQuery.parseJSON(obj);
     var location=storepick_data[details];
     var data='<input type="hidden" name="attributes[Location-Name]" value="'+location.location_name+'" /><input type="hidden" name="attributes[Address]" value="'+location.address_one+'" /><input type="hidden" name="attributes[City]" value="'+location.city+'" /><input type="hidden" name="attributes[Location-Postal-Code]" value="'+location.postal_code+'" /><input type="hidden" name="attributes[Postal-Code]" value=""/><input type="hidden" name="attributes[Delivery-Date]" value="" /><input type="hidden" name="attributes[Delivery-Time]" value="" />';
     jQuery('.hidden_fields').html(data);
}

function update_empty_attributes(){
var data='<input type="hidden" name="attributes[Location-Name]" value="" /><input type="hidden" name="attributes[Address]" value="" /><input type="hidden" name="attributes[City]" value="" /><input type="hidden" name="attributes[Location-Postal-Code]" value="" /><input type="hidden" name="attributes[Pickup-Date]" value="" /><input type="hidden" name="attributes[Pickup-Time]" value="" />';
     jQuery('.hidden_fields').html(data);

}

function getDescendantProp(obj, desc){
  	var arr = desc.split(".");
  	while(arr.length && (obj = obj[arr.shift()]));
  	return obj;
}


function offsetdata(method_name, specific_location){
    if(method_name){
        if(method_name=='pickup'){
          	var obj=  ebzapiets ;
          	var storepick_data=jQuery.parseJSON(obj);
          	var selected_location=getDescendantProp(storepick_data, specific_location);
        }
        else if(method_name=='delivery'){
          	var obj=  ebzapiets_delivery ;
          	var storepick_data=jQuery.parseJSON(obj);
            var selected_location=getDescendantProp(storepick_data, specific_location);
        }
      
      	var offset_days=['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];

      	var d = new Date(get_timezone_date('+8'));
      	var n = d.getDay();
      	var current_hour = d.getHours();
      	var current_minutes = d.getMinutes();
      	day_name=offset_days[n];

      	var selected_offset=selected_location.offset;
      	var selected_offset_day=getDescendantProp(selected_offset, day_name);

        if(selected_offset_day.before){
          	var push_day=selected_offset_day.before;
        }
     	else{
       		var push_day=0;
      	}

        if(selected_offset_day.enable_breakpoint){
          	var break_point_val=selected_offset_day.breakpoint;
          	var current_full_time=current_hour*100+(current_minutes/60*100);
            if(current_full_time>=break_point_val){
              	var push_day=selected_offset_day.after;
            }
        }
      if(push_day==0){
            if(method_name=='pickup'){
            	var selected_days=selected_location.days;
            	var selected_time_day=getDescendantProp(selected_days, day_name);
            	var last_hour=parseInt(selected_time_day.end/100);

            	if(parseInt(current_hour)>=last_hour){
              		push_day=1;
           	 	}
            }
            else if(method_name='delivery'){
            	var selected_days=selected_location.slot;
              	var selected_time_day=getDescendantProp(selected_days, day_name);
              	var found=false;
              if(selected_time_day){
                for(index_off in selected_time_day){
                  	var end_time=selected_time_day[index_off].end;
                  	var end_hrs=parseInt(end_time/100);
                    if(parseInt(current_hour)<end_hrs){
                    	found=true;
                    }
                }
            }
              else{ found=true; }
              if(!found){ push_day=1; }
            }
      }
      return push_day;
    }
}

	
function populate_date(date, method_type, specific_location){
    if(method_type){
      	var d = new Date(date);
        var select_date=d.toDateString();
      	var n = d.getDay();
      	var current_hour = d.getHours();
        var current_minutes = d.getMinutes();
        var days=['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
        day_name=days[n];
        var text='';
        var append='';

        if(method_type=='pickup'){
            var obj=  ebzapiets ;
            var storepick_data=jQuery.parseJSON(obj);
            var selected_location=getDescendantProp(storepick_data, specific_location);

            var selected_offset=selected_location.days;
			var today_d = new Date(get_timezone_date('+8'));
          	var today_d_string=today_d.toDateString();
      		var current_hour = parseInt(today_d.getHours());

            if(selected_offset.enable_pickuptime){
              	var selected_offset_day=getDescendantProp(selected_offset, day_name);

                if(!selected_offset_day.disable){
                      var first_hour=parseInt(selected_offset_day.start);
                      var last_hour=parseInt(selected_offset_day.end);

                      var text="<select name='attributes[Pickup-Time]' id='popup_time'><option value=''>Choose Time</option>";
                      var count=parseInt(first_hour);

                   if(select_date==today_d_string){
                        if(current_hour<=(count/100)){
                      		if(count%100==0){  val=parseInt(count/100)+':00'; text+='<option value="'+val+'">'+val+'</option>';   count+=100;} 
                  	  		else{  val=parseInt(count/100)+':30'; text+='<option value="'+val+'">'+val+'</option>';  count+=50;  }
                  		}
                         else{
                           if(count%100!=0){ count+=50;}
                         }
                   }
                   else{
                      	if(count%100==0){ val=parseInt(count/100)+':00'; text+='<option value="'+val+'">'+val+'</option>'; count+=100;}
                  	  	else{  val=parseInt(count/100)+':30'; text+='<option value="'+val+'">'+val+'</option>'; count+=50;}
                     }
                 
                      while(count<=last_hour){
                        if(select_date==today_d_string){
                        	if(current_hour>=(count/100)){ count+=100; continue; }
                        }
                        val=parseInt(count/100)+':00';
                        text+='<option value="'+val+'">'+val+'</option>';
                        count+=100;
                      }
                  
                  	  if(select_date==today_d_string){
                          if(last_hour%100!=0&&first_hour!=last_hour){
                              hour=parseInt(last_hour/100);
                              if(current_hour<=hour){
                                  vals=hour+':30';
                                  text+='<option value="'+vals+'">'+vals+'</option>';
                              }
                          }
                	  }
                  else{
   						if(last_hour%100!=0&&first_hour!=last_hour){
                              hour=parseInt(last_hour/100);
                                  vals=hour+':30';
                                  text+='<option value="'+vals+'">'+vals+'</option>';
                          }
                  }
                  	  text+='</select><div class="error_popuptime"></div>';
                }
            }
            else{
               	var text=''; 
            }
        }
        else if(method_type=='delivery'){
         	var obj=  ebzapiets_delivery ;
          	var storepick_data=jQuery.parseJSON(obj);
            var selected_location=getDescendantProp(storepick_data, specific_location);
          
          	var selected_offset=selected_location.slot;
          	var selected_offset_day=getDescendantProp(selected_offset, day_name);
          
          	var today_d = new Date(get_timezone_date('+8'));
          	var today_d_string=today_d.toDateString();
      		var current_hour = parseInt(today_d.getHours());
          

          if(selected_offset.enable_deliverytime){
            if(selected_offset_day){
              	var text="<select name='attributes[Delivery-Time]' id='delivery_time'><option value=''>Choose Time</option>";

                for(index_off in selected_offset_day){
                  	var start_time=selected_offset_day[index_off].start;
                  	var end_time=selected_offset_day[index_off].end;

                    if(start_time%100==0){
                      append=(start_time/100)+":00"; 
                    }
                    else{
                      var start_half = Math.floor(start_time/100);
                      append+=start_half+":30";
                    }
                  	append+=" - ";

                    if(end_time%100==0){
                      append+=(end_time/100)+":00"; 
                    }
                    else{
                      var end_half = Math.floor(end_time/100);
                      append+=end_half+":30";
                    }
                  if(select_date==today_d_string){ 
                    var end_hrs=parseInt(end_time/100);
                    if(current_hour>=end_hrs){
                       append='';
                    	continue;
                    }
                  }
                  	text+='<option value="'+append+'">Between '+append+'</option>';
                  append='';
                }
              text+='</select><div class="error_popuptime"></div>';
            }
        }
          else{  text=''; }
        }
      jQuery('#time_of_day').html(text);
    }
}

function get_timezone_date(offset){
     var obj_current= current_time;
  return obj_current;
  
  if(storepick_data['timezone']){
  offset1=storepick_data['timezone'];
  }
  else {
  offset1=8;
  }
  
    d = new Date();
    utc = d.getTime() + (d.getTimezoneOffset() * 60000);
    addtional_date=utc + (3600000*offset1);
    return addtional_date;
}

function disable_keypress(){
 $('form.cart').find('input').keypress(function(e){
    	if ( e.which == 13 ) { // Enter key = keycode 13    
      		$(this).next().focus();  //Use whatever selector necessary to focus the 'next' input
          $('.choose_date input#postal_code').blur();
      		return false;
    	}
 	});
}


      
//autocomplete api
function initialize(cods) {
  
  var input = document.getElementById('delivery_address');
  var options = {
    componentRestrictions: {
      country: 'hk'
    }
  };
  autocomplete = new google.maps.places.Autocomplete(input, options);
  google.maps.event.addListener(autocomplete, 'place_changed', function() {
    var place = autocomplete.getPlace();
    var pCode='';
    for (var i = 0; i < place.address_components.length; i++) {
      for (var j = 0; j < place.address_components[i].types.length; j++) {
        if (place.address_components[i].types[j] == "postal_code") {
          pCode=place.address_components[i].long_name;
          jQuery('input#address_postalcode').val(pCode);
         	//alert(place.address_components[i].long_name);
        }
      }
    }
    if(!pCode){ jQuery('input#address_postalcode').val(''); }
  }) 
}
      
function checkIfDelivered(postCode){
	var obj=  ebzapiets_delivery ;
	var selected_location=jQuery.parseJSON(obj);
    var postal_code_found=0;
  	var zipcodeValidation=0;
	    for(var i in selected_location){
          if(selected_location[i].enable_delivery&&selected_location[i].offset){
             if(selected_location[i].zipcode.enable_zipcode){
            zipcodeValidation=1;
            var single_delivery=selected_location[i];
            var postcode_string=single_delivery.zipcode.zip_codes;
            var postcode_array = postcode_string.split(",");
            var postal_codeLower=postCode.toLowerCase();

            if(single_delivery.zipcode.validation_type==1){
              for(var postcode in postcode_array){
                var single_value_trim=postcode_array[postcode].trim();
                if(single_value_trim){
                  var singleValueLower=single_value_trim.toLowerCase();
                  if(postal_codeLower==singleValueLower){
                    postal_code_found=1;
                    break;
                  }

                }
              }
            }
            else if(single_delivery.zipcode.validation_type==2){
              for(postcode in postcode_array){
                var single_value_trim=postcode_array[postcode].trim();
                if(single_value_trim){
                  var singleValueLower=single_value_trim.toLowerCase();
                  if(postal_codeLower.indexOf(singleValueLower)==0){
                    postal_code_found=1;
                    break;
                  }
                }
              }

            }
          }
        }
    }
  if(zipcodeValidation==1){
    if(postal_code_found==1){
      return true;
    }
    else{
      return false;
    }
  }
  else{ 
    return true;
  }
}
        
function dynamic_option(method_type, ebzapiets_delivery, add_postalcode,numberofspecialproduct,special_collection_date){
           var sptext = "Unfortunately only " +'<a style="color: red;" href="https://rosesonly.com.hk/collections/valentines-roses" target="_blank">'+ " Valentine's day collection"+"</a> is available for delivery during 1st Feb - 9th Feb and 13th Feb - 16th Feb.";
	       if(method_type=='delivery'){
         	var obj=  ebzapiets_delivery ;
			var selected_location=jQuery.parseJSON(obj);
         	var showzipcode=true;
            for(var i in selected_location){
                  if(selected_location[i].enable_delivery){
                    if(selected_location[i].zipcode.enable_zipcode){
                    	showzipcode=true;
                    }
                    else{
                    	showzipcode=false;
                      	enable_zip_validate=false;
                      	break;
                    }
                  }
            }
             if(showzipcode){
               if(add_postalcode){
                 jQuery('#cart_tabs .postal_codevalidate').html('<input type="text" name="attributes[Postal-Code]" id="postal_code" placeholder="Please Enter your Postcode" value="'+add_postalcode+'" required/><div class="error_postal"></div>');
                 jQuery('.delivery-note').html('Please select date we will load available time.');
                 jQuery('.choose_date input#postal_code').trigger('blur');
               }
               else{
                 jQuery('#cart_tabs .postal_codevalidate').html('<input type="text" name="attributes[Postal-Code]" id="postal_code" placeholder="Please Enter your Postcode" required/><div class="error_postal"></div>');
                 jQuery('.delivery-note').html('Please enter your postcode and we will load available dates.');
               }
               disable_keypress();
             }
             else{
               jQuery('#cart_tabs .postal_codevalidate').html('');
               jQuery('.delivery-note').html('Please select date and we will load available time.');
               for(var i in selected_location){
                 if(selected_location[i].enable_delivery&&selected_location[i].offset){
                   specific_location=i;
                   var push_d=offsetdata(method_type,specific_location);
                   if(!push_d){ push_d=0; }
                   var dateToday = new Date(get_timezone_date('+8'));

                   var myday=dateToday.setDate(dateToday.getDate() + parseInt(push_d));
                   var push=new Date(myday);
                   if (numberofspecialproduct) {
                     var push = special_date_init(special_collection_date,push_d);
                   }
                   jQuery('.choose_date .datepickerWrapper').html('<span class="formatteddate"></span><input type="hidden" name="attributes[Delivery-Date]" id="date_picker" placeholder="Please Choose Date above." required readonly /><div class="error_datepicker"></div>');
                   jQuery("#datepicker").datepicker({
                     dateFormat: 'yy/mm/dd',
                     minDate: push,
                     firstDay: 1,
                     showOtherMonths: true,
                     selectOtherMonths: false,
                     beforeShowDay: function (date){
                       return noWeekendsOrHolidays(date, 'delivery', specific_location,numberofspecialproduct,special_collection_date);
                     },
                     onSelect: function(dateText, instobj) {
                       var selectedDate = $(this).val();
                       var msg_for_special_date = specialdatemessage(special_collection_date,numberofspecialproduct,selectedDate);
                       if (msg_for_special_date) {
                         jQuery('error_datepicker').html('');
                         jQuery('input[name="checkout[attributes][Delivery-Date]"]').val('');
                         jQuery('#time_of_day').hide();
                         jQuery('span.formatteddate').html(sptext).css({'color': '#a81c20','font-style': 'bold','font-size': '12px'});
                       }
                       else {
                       jQuery(this).data('datepicker').inline = true;
                       jQuery('input[name="attributes[Delivery-Date]"]').val(dateText);
                       cltr=dateFormat(dateText,'dddd dS mmm yyyy');
                       jQuery('span.formatteddate').html(cltr);
                       jQuery('.error_datepicker').html('');
                       jQuery('#time_of_day').show();
                       populate_date(dateText, 'delivery', specific_location);
                       $("#time_of_day select").niceSelect();
                       }
                     }
                   }); 	
                 }
                 break;
               }
               setTimeout(function() {
                 $(document).find('td.ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
               }, 100);
             }

             if(jQuery('.choose_date input#postal_code').length){
               jQuery('.choose_date input#postal_code').on('blur',function(){
                 var delivery_postalcode=jQuery('.choose_date input#postal_code').val().trim();
                 if(delivery_postalcode){
                   var postal_code_found=0;
                   for(var i in selected_location){
                     if(selected_location[i].enable_delivery&&selected_location[i].offset){
                       var single_delivery=selected_location[i];
                       var postcode_string=single_delivery.zipcode.zip_codes;
                       var postcode_array = postcode_string.split(",");

                       var postal_codeLower=delivery_postalcode.toLowerCase();

                       if(single_delivery.zipcode.validation_type==1){
                         for(var postcode in postcode_array){
                           var single_value_trim=postcode_array[postcode].trim();
                           if(single_value_trim){
                             var singleValueLower=single_value_trim.toLowerCase();
                             if(postal_codeLower==singleValueLower){
                               delivery_grp=i;
                               postal_code_found=1;
                               break;
                             }

                           }
                         }
                 	 }
                    else if(single_delivery.zipcode.validation_type==2){
                    	 for(postcode in postcode_array){
                           	var single_value_trim=postcode_array[postcode].trim();
                           	if(single_value_trim){
                              	var singleValueLower=single_value_trim.toLowerCase();
                                if(postal_codeLower.indexOf(singleValueLower)==0){
                                   delivery_grp=i;
                                    postal_code_found=1;
                                break;
                                }
                            }
                  		}
                    
                    }
                  }
                }
                
                   if(postal_code_found&&delivery_grp!=''){
                     jQuery('.choose_date .datepickerWrapper').html('<span class="formatteddate"></span><input type="hidden" name="attributes[Delivery-Date]" id="date_picker" placeholder="Please Choose Date above." required readonly /><div class="error_datepicker"></div>');

                     var push_d=offsetdata('delivery',delivery_grp);
                     if(!push_d){ push_d=0; }
                     var dateToday = new Date(get_timezone_date('+8'));

                     var myday=dateToday.setDate(dateToday.getDate() + parseInt(push_d));
                     var push=new Date(myday);
                     if (numberofspecialproduct) {
                       var push = special_date_init(special_collection_date,push_d);
                     }

                     $("#datepicker").datepicker("destroy");
                     jQuery("#datepicker").datepicker({
                       dateFormat: 'yy/mm/dd',
                       minDate: push,
                       firstDay: 1,
                       showOtherMonths: true,
                       selectOtherMonths: false,
                       beforeShowDay: function (date){
                         return noWeekendsOrHolidays(date, 'delivery', delivery_grp,numberofspecialproduct,special_collection_date);
                       },
                       onSelect: function(dateText, instobj) {
                         var selectedDate = $(this).val();
                         var msg_for_special_date = specialdatemessage(special_collection_date,numberofspecialproduct,selectedDate);
                         if (msg_for_special_date) {
                           jQuery('error_datepicker').html('');
                           jQuery('input[name="checkout[attributes][Delivery-Date]"]').val('');
                           jQuery('#time_of_day').hide();
                           jQuery('span.formatteddate').html(sptext).css({'color': '#a81c20','font-style': 'bold','font-size': '12px'});
                         }
                         else {
                         jQuery(this).data('datepicker').inline = true;
                         jQuery('input[name="attributes[Delivery-Date]"]').val(dateText);
                         cltr=dateFormat(dateText,'dddd dS mmm yyyy');
                         jQuery('span.formatteddate').html(cltr);
                         jQuery('.error_datepicker').html('');
                         jQuery('#time_of_day').show();
                         populate_date(dateText, 'delivery', delivery_grp);
                         $("#time_of_day select").niceSelect();
                         }
                       }
                     });
                     jQuery('.delivery-note').html('Please select date and we will load available time.');

                     jQuery('.choose_date div.error_postal').html('');
                   }
                   else{
                     jQuery('.choose_date div.error_postal').html('Sorry, the delivery is not available in that Postcode.');
                   }
                 }
                 else{
                   jQuery('.choose_date div.error_postal').html('Please Enter Postcode.');
                 }
                 setTimeout(function() {
                   $(document).find('td.ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
                 }, 100);
               });
             }
           }
       
       if(method_type=='pickup'){
         jQuery('.delivery-note').html('Please select a date for pickup. <strong>Note: Your ID and Credit Card used must be presented for collection.</strong>');
         var push_d=offsetdata(method_type,specific_location);
         if(!push_d){ push_d=0; }
         var dateToday = new Date(get_timezone_date('+8'));
         var myday=dateToday.setDate(dateToday.getDate() + parseInt(push_d));
         var push=new Date(myday);
         if (numberofspecialproduct) {
           var push = special_date_init(special_collection_date,push_d);
         }
         jQuery('.choose_date .datepickerWrapper').html('<span class="formatteddate"></span><input type="hidden" name="attributes[Pickup-Date]" id="date_picker" placeholder="Please Choose Date above." required readonly /><div class="error_datepicker"></div>');
         jQuery("#datepicker").datepicker({
           dateFormat: 'yy/mm/dd',
           minDate: push,
           firstDay: 1,
           showOtherMonths: true,
           selectOtherMonths: false,
           beforeShowDay: function (date){
             return noWeekendsOrHolidays(date, 'pickup', specific_location,numberofspecialproduct,special_collection_date);
           },
           onSelect: function(dateText, instobj) {
             var selectedDate = $(this).val();
             var msg_for_special_date = specialdatemessage(special_collection_date,numberofspecialproduct,selectedDate);
             if (msg_for_special_date) {
               jQuery('.error_datepicker').html('');
               jQuery('#time_of_day').hide();
               jQuery('input[name="checkout[attributes][Pickup-Date]"]').val('');
               jQuery('span.formatteddate').html(sptext).css({'color': '#a81c20','font-style': 'bold','font-size': '12px'});;
             }
             else {
             jQuery(this).data('datepicker').inline = true;
             jQuery('input[name="attributes[Pickup-Date]"]').val(dateText);
             cltr=dateFormat(dateText,'dddd dS mmm yyyy');
             jQuery('span.formatteddate').html(cltr);
             jQuery('.error_datepicker').html('');
             jQuery('#time_of_day').show();
             populate_date(dateText, method_type, specific_location);
             $("#time_of_day select").niceSelect();
             }
           }
         }); 
       }
  setTimeout(function() {
    $(document).find('td.ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
  }, 100);

}

function special_date_init(special_collection_date,push_d){
    
          var special_collection_date =special_collection_date.split(",");
          var dateToday = new Date(get_timezone_date('+8'));
          var dateToday = dateToday.setDate(dateToday.getDate() + parseInt(push_d));
          var dateToday = new Date(dateToday);
           for(var i=0; i< special_collection_date.length; i++) {
            //var dateSpecial = new Date(special_collection_date[i]);
            var dateSpecial = formatteddate(special_collection_date[i]);
            dateSpecial = (dateSpecial.toString());
            dateSpecial = (dateSpecial.substring(0, 15));
            var gmt = (dateToday.toString().substring(15, 33));
            var dateSpecial_gmt = dateSpecial.concat(gmt);
              if ((+new Date(dateSpecial_gmt) > +new Date(dateToday)) || (+new Date(dateSpecial_gmt) == +new Date(dateToday)) ) {
                 
                 var push = new Date(dateSpecial_gmt);
                 return push;
                 break;
              }
              
                   
           }
}

function formatteddate(push) {

  var d = new Date(push.replace(/-/g, "/"));
  var curr_date = d.getDate();
  var curr_month = d.getMonth();
  curr_month++;
  var curr_year = d.getFullYear();
  var push = curr_year + "/" + curr_month + "/" + curr_date;
  return push;

}

function specialdatemessage(special_collection_date,mixedcollections,selectedDate) {
      if (!mixedcollections) {
       var special_collection_date =special_collection_date.split(",");
       for(var i=0; i< special_collection_date.length; i++) {
            var special_date = formatteddate(special_collection_date[i]);
            var special_date = dateFormat(special_date,'yyyy/mm/dd');
            if (special_date == selectedDate) {
             return true;
             break;
            }
        }
        
     }
  else {
    return false;
  }
}
